import { MantineProvider, Modal } from "@mantine/core";
import "./index.css";
import { BrowserRouter, Route, Routes, useLocation, useNavigate } from "react-router";
import MainPage from "./pages/MainPage";
import MainLayout from "./MainLayout";
import LoginPage from "./pages/admin/LoginPage";
import AdminLayout from "./pages/admin/AdminLayout";
import DashboardPage from "./pages/admin/DashboardPage";
import CategoriesPage from "./pages/admin/CategoriesPage";
import SubCategoriesPage from "./pages/admin/SubCategoriesPage";
import ProductsPage from "./pages/admin/ProductsPage";
import ReviewsPage from "./pages/admin/ReviewsPage";
import HeroBlocksPage from "./pages/admin/HeroBlocksPage";
import ApplicationsPage from "./pages/admin/ApplicationsPage";
import CatalogPage from "./pages/catalog/CatalogPage";
import { ApplicationFormProvider } from "./lib/ApplicationFormContext";
import { ApplicationForm } from "./widgets/ApplicationForm";
import { TestPage } from "./pages/TestPage";

function ApplicationFormModalRoute() {
  const navigate = useNavigate();
  return (
    <Modal
      opened
      onClose={() => navigate(-1)}
      fullScreen
      padding={0}
      withCloseButton={false}
      zIndex={10000}
      classNames={{
        content: "!bg-transparent !shadow-none",
        body: "!p-0 !h-full",
      }}
    >
      <ApplicationForm />
    </Modal>
  );
}

function RoutesLayout() {
  const location = useLocation();
  const state = location.state as { backgroundLocation?: typeof location } | null;
  const backgroundLocation = state?.backgroundLocation;

  return (
    <>
      {/* Main routes render either the real location or the background one (when a modal is open) */}
      <Routes location={backgroundLocation ?? location}>
        <Route path="admin/login" element={<LoginPage />} />
        <Route path="admin" element={<AdminLayout />}>
          <Route index element={<DashboardPage />} />
          <Route path="categories" element={<CategoriesPage />} />
          <Route path="subcategories" element={<SubCategoriesPage />} />
          <Route path="products" element={<ProductsPage />} />
          <Route path="reviews" element={<ReviewsPage />} />
          <Route path="hero-blocks" element={<HeroBlocksPage />} />
          <Route path="applications" element={<ApplicationsPage />} />
        </Route>
        {/* Direct navigation to /application should still work as a normal page */}
        <Route path="application" element={<ApplicationForm />} />
        <Route element={<MainLayout />}>
          <Route index element={<MainPage />} />
          <Route path="catalog" element={<CatalogPage />} />
          <Route path="test" element={<TestPage />} />
        </Route>
      </Routes>

      {/* If we have a background location, show /application as a modal on top */}
      {backgroundLocation && (
        <Routes>
          <Route path="application" element={<ApplicationFormModalRoute />} />
        </Routes>
      )}
    </>
  );
}

export function App() {
  return (
    <MantineProvider>
      <BrowserRouter basename={process.env.BASENAME}>
        <ApplicationFormProvider>
          <RoutesLayout />
        </ApplicationFormProvider>
      </BrowserRouter>
    </MantineProvider>
  );
}

export default App;
